// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"R3-z","colorTextValue":"S3-z","swatches":"T3-z","collapseLink":"U3-z","isCollapsed":"V3-z","dropdown":"W3-z","disabled":"X3-z"};